export const needPromiseApis = new Set([
  'authPrivateMessage',
  'disableAlertBeforeUnload',
  'enableAlertBeforeUnload',
  'getBackgroundFetchData',
  'getGroupEnterInfo',
  'getShareInfo',
  'getWeRunData',
  'join1v1Chat',
  'openVideoEditor',
  'saveFileToDisk',
  'scanItem',
  'setEnable1v1Chat',
  'setWindowSize',
  'sendBizRedPacket',
  'startFacialRecognitionVerify'
])
